import { userSchema } from '@scalar-org/entities/user'

import type { getDatabaseClient } from '@/helpers'

export const getUserTeams = async (
  client: Awaited<ReturnType<typeof getDatabaseClient>>,
  email: string,
) => {
  const user = await client.getOne({
    collectionPath: 'users',
    query: { email },
    schema: userSchema,
  })

  if (user.error) return user

  return { error: false, data: user.data.teams }
}
